import { SelectionModel } from '@angular/cdk/collections';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PageEvent } from '@angular/material';
import { Subscription } from 'rxjs';
import { Patient } from 'src/app/core/model/patient';
import { SearchPatientReq, SearchPatientRes } from 'src/app/core/model/v2/practice/searchPatientList';
import { Employer } from 'src/app/core/models/employer/employer';
import { CommonService } from 'src/app/core/services/v2/common.service';
import { EmployerService } from 'src/app/core/services/v2/employer.service';
import { PracticeService } from 'src/app/core/services/v2/practice.service';
import { SharedService } from 'src/app/core/services/v2/shared-employees-data.service';
import { EmployerNamesService } from 'src/app/core/services/v2/shared-employer-names.service';
import { UserService } from 'src/app/core/services/v2/user.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-agency-employee',
  templateUrl: './agency-employee.component.html',
  styleUrls: ['./agency-employee.component.scss']
})
export class AgencyEmployeeComponent implements OnInit {
  pageLength = 10;
  pageIndex = 1;
  dataLength;
  activeId: number;
  togglePatientProfileSidebar = this.commonService.togglePatientProfileSidebar;
  showPatientProfile: boolean = false;

  searchData: Patient[];
  openSection: string;
  user: any = [];
  employersList: Employer[] = [];
  // displayedColumns: string[] = [
  //   "EmployerName",
  // ];
  displayedColumns: string[] = [
    // "checkbox",
    "patientName",
    "email",
    //"gender",
    // "contact",
    "userId",
    "lastLoginDate",
    "HSA",
    // "FSA",
    "planSubscription",
    "employerSponser",
    "actions"
    // "aptDateTime",
    // "nextAptDateTime",
    // "symptoms",
    // "action",
  ];
  dataSource: SearchPatientRes[];
    employeeList: Patient[] = [];
    selectedEmpId: number;
  employerControl = new FormControl(); // FormControl to bind to the dropdown
  selectedEmployer: Employer | null = null; // Store the selected employer
  totalRecordsActive: number;
  toggleSidebar = false;
  sectionName: string = "referPatient";
    selectedPatient: Patient;
    selection = new SelectionModel<any>(true, []);
    sideBarHeader: string;
    private subscription: Subscription;
  constructor(private employerNamesService: EmployerNamesService, private loaderService: WindowLoaderService,    private commonService: CommonService,
  
    private employerService: EmployerService,  private sharedService: SharedService,private _userService: UserService, private practiceService: PracticeService,
  ) { }

  ngOnInit() {
    // this.loaderService.show();

    //     // Subscribe to the employers observable to get the data
    //     this.employerNamesService.employers$.subscribe(
    //       (employers) => {
    //         this.employersList = employers;
    //         console.log('Updated Employers List:', this.employersList);
    //           // Set the first employer as default selection (or select a specific employer)
    //     if (this.employersList.length > 0) {
    //       this.employerControl.setValue(this.employersList[4]);  // Set first employer as default
    //     }
    //         this.loaderService.hide();

    //       },
    //       (error) => {
    //         console.error('Error fetching employers data:', error);
    //       },
    //       () => {
    //         // Hide loader once data fetching is complete
    //         this.loaderService.hide();
    //       }
    //     );
    this.getUserDetails();

    console.log(history.state.data)
    if(history.state.data && history.state.data.id)
    this.selectedEmpId = history.state.data.id;
  }
  loadEmployers() {
    // this.loaderService.show();
    this.employerService
      .GetAllActiveInActiveRegistrations(1, 500,2)
      .subscribe(
        (employers) => {
          console.log("employer list",employers)
         this.employersList =  this.sortById(employers.pageItems);
           console.log("this.employerlist",this.employersList)
          
          if (this.employersList.length > 0) {
            if(this.selectedEmpId > 0){
              this.employerControl.setValue(this.employersList.filter((emp)=> emp.id == this.selectedEmpId)[0]);
              this.handleEmployerChange({value:{id:this.selectedEmpId}});  
            }
            else{
            this.employerControl.setValue(this.employersList[0]);  // Set first employer as default
            this.handleEmployerChange({value:{id:this.employersList[0].id}});  
          }
          }
         
       },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        },
        () => {
          this.loaderService.hide();
        }
      );
   }
   sortById(data: any) {
    return data.sort(function (a, b) {
      return -(a.id - b.id);
    });
  }
  dropDownEmployerSelect(event: any) {
    // Handle the selected employer
    this.selectedEmployer = event.value;
    console.log('Selected Employer:', this.selectedEmployer);
    // this.loaderService.blockWithLoader(this.employerService.getEmployerDataByName(this.page, this.pageSize, employer.value, 1)).subscribe(
    //   (details) => {
    //     if (details) {
    //       this.employersList = this.sortById(details.pageItems);
    //       this.totalRecordsActive = details.totalRecords;
    //       this.dataLength = details.totalRecords;
    //       if (this.dataLength < (this.pageSize - 1) * this.page)
    //         this.pageSize = 1;
    //     }
    //     else {
    //       this.loadEmployers();
    //       this._snackBar.open('Employer not found.', 'Ok', { duration: 5 * 1000 });
    //     }
    //   },
    //   (error) => { console.error(error); }
    // );
    // You can now perform any additional logic here with the selected employer, e.g., updating a form or triggering another service
  }
  getUserDetails() {
    // this.loaderService.show();
    this._userService.getUserDetails().subscribe(
      (result) => {
        this.user = result;
        this.loadEmployers();
      },
      (error) => {
        console.error(error);
      }
    );
  }
    searchPatient(data) {
      const searchReq: SearchPatientReq = new SearchPatientReq();
      // searchReq.userId = this.physicianOptionService.getPhysician().userId;
      const currentUserId = data.id;  // Assuming employer has a userId property
      const searchCriteria = data.criteria;  // Assuming employer has a criteria property
      searchReq.healthOrganizationId = this.user.healthOrganizationId;
      searchReq.employerId = currentUserId;
      searchReq.parenttype = "employer";

      searchReq.pageIndex = this.pageIndex;
      searchReq.itemsCount = this.pageLength;
      searchReq.criteria = searchCriteria;
  
      if (searchReq.healthOrganizationId) {
        this.loaderService.show();
        this.practiceService.GetPatientsListByOrgId(searchReq).subscribe(
          (res) => {
            this.searchData = res.patients;
            this.dataSource = res.patients;
            this.dataLength = res.totalRecords;
            if (this.dataLength < (this.pageIndex - 1) * this.pageLength)
              this.pageIndex = 1;
  
            this.loaderService.hide();
          },
          (error) => {
            console.error(error);
            this.loaderService.hide();
          },
          () => {
            this.loaderService.hide();
          }
        );
      }
    }
  handleEmployerChange(event: any): void {
    this.selectedEmpId = event.value.id;
  this.searchPatient(event.value);
    // // Pass dynamic parameters to searchPatient
    // this.sharedService.searchPatient(currentUserId, 1, 10, "").subscribe(
    //   (res) => {
    //     console.log('Search Results:', res);  // Log the search results
    //     this.employeeList = res.patients;
    //     console.log('employee List Results:',  this.employeeList);  // Log the search results
    //     this.totalRecordsActive = res.totalRecords;
    //     this.dataLength = res.totalRecords;
    //     if (this.dataLength < (this.pageSize - 1) * this.page)
    //       this.pageSize = 1;
    //   },
    //   (error) => {
    //     console.error('Search Error:', error);  // Log any errors
    //   }
    // );
  }

    changeIndex(event: PageEvent) {
      this.pageLength = event.pageSize;
      this.pageIndex = event.pageIndex + 1;  
      this.searchPatient({ id: this.selectedEmpId });  // Fetch new data
    }
    togglePatientSidebar(element) {
      this.selectedPatient = element;
      this.openSection = 'profile';
      this.togglePatientProfileSidebar = !this.togglePatientProfileSidebar;
      this.showPatientProfile = !this.showPatientProfile;
    }
    
    toggleEditSidebar(
        sectionName: string,
        patient: Patient,
        sideBarHeader: string
      ) {
    
        if (sectionName !== 'close') {
          this.sectionName = sectionName;
          if (this.sectionName == "communicateMultiplePatient") {
            //this.selection.select(...this.dataSource);
            this.selection = new SelectionModel<SearchPatientRes>(true, [...this.dataSource])
          }
          this.sideBarHeader = sideBarHeader;
          this.selectedPatient = patient;
          this.showHideScroll(this.toggleSidebar);
        }
        this.toggleSidebar = !this.toggleSidebar;
       // this.destroyChild();
      }
    
      togglePopUp() {
        // this.practitionerData = pracdata;
        this.toggleSidebar = !this.toggleSidebar;
        this.showHideScroll(this.toggleSidebar);
       // this.destroyChild();
      }
  
      showHideScroll(isOpen: boolean) {
        /* To stop body scroll while sidebar is Open */
        const body = document.querySelector("body");
        if (isOpen) {
          body.style.cssText = "height:100vh; overflow:hidden";
        } else {
          body.style.cssText = "height:auto; overflow:visible";
        }
      }

}
